import ApplicationAdapter from 'eflex/adapters/application';

export default class RestPullBomSourceAdapter extends ApplicationAdapter {
  pathForType() {
    return 'bomSources';
  }
}
